import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PanelType = "search" | "cart" | "wishlist";

export interface MultiPanelOffcanvasState {
  isOpen: boolean;
  activePanel: PanelType | null;
}

const initialState: MultiPanelOffcanvasState = {
  isOpen: false,
  activePanel: null,
};

export const multiPanelOffcanvasSlice = createSlice({
  name: "multiPanelOffcanvas",
  initialState,
  reducers: {
    /**
     * Opens the offcanvas and sets the specified panel as active.
     */
    openMultiPanelOffcanvas: (state, action: PayloadAction<PanelType>) => {
      state.isOpen = true;
      state.activePanel = action.payload;
    },
    /**
     * Closes the offcanvas and resets the active panel.
     */
    closeMultiPanelOffcanvas: (state) => {
      state.isOpen = false;
      state.activePanel = null;
    },
    /**
     * Switches the active panel without closing the offcanvas.
     */
    setMultiPanelActivePanel: (state, action: PayloadAction<PanelType>) => {
      if (state.isOpen) {
        state.activePanel = action.payload;
      }
    },
  },
});

export const {
  openMultiPanelOffcanvas,
  closeMultiPanelOffcanvas,
  setMultiPanelActivePanel,
} = multiPanelOffcanvasSlice.actions;

export default multiPanelOffcanvasSlice.reducer;
